import { BadgeIndianRupee, BriefcaseBusiness, GraduationCap, Sparkles, Timer } from "lucide-react";

const details = [
  { key: "trade", label: "Trade", icon: BriefcaseBusiness },
  { key: "education", label: "Education", icon: GraduationCap },
  { key: "work_type", label: "Work Type", icon: Timer },
  { key: "stipend", label: "Salary", icon: BadgeIndianRupee },
  { key: "experience", label: "Experience", icon: Sparkles },
];

export default function JobInfoGrid({ job }) {
  return <section className="job-info-grid" data-testid="job-info-grid">{details.map((detail) => { const Icon = detail.icon; return <div className="job-info-card" key={detail.key} data-testid={`job-info-${detail.key}`}><span className="job-info-icon"><Icon size={18} /></span><div><small>{detail.label}</small><strong>{job[detail.key] || "—"}</strong></div></div>; })}</section>;
}